<life-di-nav></life-di-nav>

<mat-spinner class="spinner-center" *ngIf="isLoading"></mat-spinner>

<div class="container mt-5">
  <h1 class="text-center lifedi-color">การแจ้งเตือน</h1> <br>

  <div class="row mb-3">
    <label class="offset-lg-8 col-lg-1 offset-md-6 col-md-2 col-sm-3 col-3 col-form-label text-center">คัดกรอง</label>
    <div class="col-lg-3 col-md-4 col-sm-9 col-9">
      <select [(ngModel)]="filter" class="custom-select" id="type" (change)="getNotiByType()">
        <option value="all" selected>ทั้งหมด</option>
        <option value="read">อ่านแล้ว</option>
        <option value="unread">ยังไม่อ่าน</option>
      </select>
      <button *ngIf="filter === 'unread'" type="button" class="btn btn-link float-right p-0 mt-2" (click)="readAll()">
        <small>✔ ทำเครื่องหมายอ่านแล้วทั้งหมด</small>
      </button>
    </div>
  </div>

  <div *ngIf="rows && !isLoading" class="row mx-auto w-100 pb-3">
    <a *ngFor="let noti of rows;" class="list-group-item list-group-item-action flex-column align-items-start"
      (click)="updateStatusNoti(noti)">
      <div class="d-flex w-100 justify-content-between">
        <h6 [ngClass]="noti.NOTI_STATUS === 0 ? 'unread' : null" class="mb-1">{{ noti.NOTI_TITLE }}</h6>
        <small class="text-muted">
          <span *ngIf="noti.NOTI_STATUS === 0" class="unread">•</span> {{ noti.CREATE_DATE | dateTimeAgo: second }}
        </small>
      </div>
      <small class="text-muted cut-text" [innerHTML]="noti.NOTI_DETAIL"></small>
    </a>

    <div *ngIf="getLength(rows) === 0 && !isLoading" class="p-3 text-center text-muted m-auto">
      ยังไม่มีการแจ้งเตือน
    </div>
  </div>

  <div *ngIf="rows && !isLoading" class="d-flex justify-content-center p-2">
    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" (pageChange)="refresh()">
    </ngb-pagination>
  </div>
</div>
